import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

// ── DEV ONLY: route WorkOS token calls through a same-origin proxy ───────────
// WorkOS's CORS allowlist is prod-origin only, so a token fetch straight from
// https://localhost:5173 is BLOCKED and login is impossible — the console shows
// "blocked by CORS policy: No 'Access-Control-Allow-Origin' header".
//
// This shim rewrites api.workos.com fetches onto /__workos, which vite.config.ts
// proxies server-side (no CORS). THE TWO HALVES ONLY WORK TOGETHER — if you ever
// find one without the other, login is broken. That has now happened twice
// (2026-07-28 and 2026-07-29), both times because these lived only in the working
// tree and a git operation removed them. They are committed for that reason: the
// whole block is compiled out of a production build, since import.meta.env.DEV is
// statically false there.
//
// The authorize NAVIGATION is untouched — it already round-trips a code fine.
if (import.meta.env.DEV) {
  const WORKOS = "https://api.workos.com";
  const origFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url =
      typeof input === "string"
        ? input
        : input instanceof Request
          ? input.url
          : String(input);
    if (url.startsWith(WORKOS)) {
      const rewritten = "/__workos" + url.slice(WORKOS.length);
      return input instanceof Request
        ? origFetch(new Request(rewritten, input), init)
        : origFetch(rewritten, init);
    }
    return origFetch(input, init);
  };
}

// build-salt: changing this string changes the bundle hash. It MUST be a real
// side effect (globalThis assignment) — an inert const gets tree-shaken and
// the hash doesn't move. Used to abandon poisoned CF edge-cache entries for
// /assets/index-*.js (deploy-window incident #2, 2026-06-11).
// ⛔ INCIDENT #8, 2026-08-20 (Quinn) — AND I CAUSED IT WITH MY OWN VERIFICATION.
// Remy's note at src/index.css:251 describes this exactly and I had not read it
// before deploying: the custom domain serves the new index.html a beat before it
// will serve that build's hashed assets, so a check that reads `/` and then
// immediately requests the asset it names lands in the gap, gets the SPA
// fallback, and CF stores THAT under the hashed URL as immutable/max-age=1yr.
// I ran precisely that loop after each of three pushes in twenty-five minutes.
// Measured at the time: canonical `/assets/index-DbhKQMsa.js` -> text/html 1145 B
// for 5+ minutes, while the SAME url with `?v=1` -> application/javascript
// 5,067,017 B. So the deploy was always fine; only the cached canonical entry
// was bad. CSS was clean on both variants, so ONLY this salt moves — the same
// restraint Remy showed on #5, and the rule the shared-file gate names.
// THE FIX IS THE PROCEDURE, NOT THIS LINE: after deploying, poll with `?v=1`
// until the type is right, and only then touch the canonical URL, once.
(globalThis as Record<string, unknown>).__BUILD_SALT__ = "2026-08-20-quinn-js-unpoison-v10";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

(globalThis as unknown as { __BUILD_ID__?: string }).__BUILD_ID__ = "jarvis-20260731-js-unpoison-v3";
